const ID_EMAIL = 'E';
const EMAIL = {
	codigo: ID_EMAIL,
	nome: 'Email'
}

const ID_PLATAFORMA = 'P';
const PLATAFORMA = {
	codigo: ID_PLATAFORMA,
	nome: 'Área de Comunicação da Plataforma de Gestão'
}


export {ID_EMAIL, ID_PLATAFORMA, EMAIL, PLATAFORMA }